export default __webpack_public_path__ + "static/media/pizza-dummy.bfda7cd9.png";